export default __webpack_public_path__ + "img/cloudy-storm.b1cf60f.svg";